import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlugCircleXmark } from "@fortawesome/free-solid-svg-icons";
import { useOnline } from "../../hooks/useOnline";
import styles from "./offlineBanner.module.scss";

// A persistent (non-dismissible) status row, the same "second header row"
// shape as LanguagePromptBanner - on mobile there's no room for an inline
// icon in the main row, so this renders below it instead, at every width.
function OfflineBanner() {
    const { t } = useTranslation();
    const online = useOnline();

    if (online) return null;

    return (
        <aside className={styles.banner} role="status">
            <FontAwesomeIcon icon={faPlugCircleXmark} className={styles.icon} aria-hidden="true" />
            <span className={styles.text}>{t("offlineBanner.message")}</span>
        </aside>
    );
}

export default OfflineBanner;
